import { useTranslation } from 'react-i18next';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';
import { Icon } from '@/components/common/Icon';

interface RescheduleRequestMarkerProps {
  appointment: Appointment;
}

export function RescheduleRequestMarker({ appointment }: RescheduleRequestMarkerProps) {
  const { t } = useTranslation('appointments');
  if (appointment.rescheduleRequestedAt === null) {
    return null;
  }
  const label = t('clientRequest.markerLabel');
  return (
    <span role="img" aria-label={label} title={label} className="text-zoowarningtext shrink-0">
      <Icon name="RefreshCw" />
    </span>
  );
}
